import CryptoJS from 'crypto-js';

// 客户端混淆密钥：避免敏感数据以明文形式落盘到 localStorage
// 策略：首次使用时生成随机密钥并持久化到 localStorage，静态 fallback 仅用于兼容旧数据
const CIPHER_KEY = 'xf_cipher_v2';
const OLD_CIPHER = 'xf-remember-cipher-v1';

function getCipher(): string {
  try {
    let key = localStorage.getItem(CIPHER_KEY);
    if (!key) {
      key = Array.from(crypto.getRandomValues(new Uint8Array(16)))
        .map(b => b.toString(16).padStart(2, '0')).join('');
      localStorage.setItem(CIPHER_KEY, key);
    }
    return key;
  } catch {
    return OLD_CIPHER; // SSR / 无 localStorage 环境回退
  }
}

// 字符串加密（用于密码、token 等敏感文本）
export function encryptString(plain: string): string {
  if (!plain) return '';
  return CryptoJS.AES.encrypt(plain, getCipher()).toString();
}

export function decryptString(cipher: string): string {
  if (!cipher) return '';
  try {
    // 尝试新密钥
    const bytes = CryptoJS.AES.decrypt(cipher, getCipher());
    const result = bytes.toString(CryptoJS.enc.Utf8);
    if (result) return result;
    // 回退旧密钥（兼容 v3.6.56 之前的加密数据，下次写入时自动用新密钥）
    const oldBytes = CryptoJS.AES.decrypt(cipher, OLD_CIPHER);
    const oldResult = oldBytes.toString(CryptoJS.enc.Utf8);
    return oldResult || '';
  } catch {
    return '';
  }
}

// 对象加密（用于需要整体加密的 payload）
export function encryptPayload(data: object): string {
  return encryptString(JSON.stringify(data));
}

export function decryptPayload(encrypted: string): object | null {
  try {
    const json = decryptString(encrypted);
    return json ? JSON.parse(json) : null;
  } catch (e: any) {
    console.warn('[crypto] payload 解析失败，已忽略:', e?.message || e);
    return null;
  }
}
